<div
    [attr.id]="id"
    class='agpr-rightSidebar'
    [ngClass]="{
        'agpr-rightSidebar--collapsible': _collapsible && overlayContainer,
        'agpr-rightSidebar--contentCollapsible': contentCollapseToggle,
    }"
    [ngStyle]="{
        'width': _collapsible
            ? (!overlay ? '2.5rem' : 'calc(2.5rem + ' + (contentWidth || '30vw') + ')')
            : (contentWidth ? 'calc(2.5rem + ' + contentWidth + ')' : undefined)
    }"
    (clickOutside)="clickOutside($event)"
    [clickOutsideEnabled]="!!overlay"
    [exclude]="clickOutsideExcluded"
    [excludeBeforeClick]="true"
    [cdkTrapFocus]="!!overlay"
    [cdkTrapFocusAutoCapture]="!!overlay"
>
    <agpr-button
        *ngIf="overlay"
        class="agpr-rightSidebar-focusClose"
        [style]="buttonTypes.icon"
        icon="fa-regular fa-duotone fa-xmark"
        tooltip="close"
        (click)="closeFocus()"
    ></agpr-button>

    @if (contentCollapseToggle) {
        <div class="contentCollapseToggle">
            <agpr-button
                class="contentCollapseToggle-button"
                [style]="buttonTypes.icon"
                [icon]="contentCollapsed ? 'fa-solid fa-angle-left' : 'fa-solid fa-angle-right'"
                (click)="toggleContent()"
            ></agpr-button>
            <div class="contentCollapseToggle-line"></div>
        </div>
    }
    <div
        #container
        [attr.id]="id ? (id + '_container') : null"
        class="agpr-rightSidebar-container"
        [class.agpr-rightSidebar-container--expanded]="_expanded"
        [class.agpr-rightSidebar-container--contentCollapsed]="contentCollapsed"
        [@contentCollapse]="contentCollapseAnimation"
        (@contentCollapse.done)="contentCollapseComplete($event)"
        [@slide]="slideAnimation"
        (@slide.done)="slideAnimationComplete($event)"
    >
        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
        @if (tabs?.length > 0) {
            <ul
                [attr.id]="id ? (id + '_tabs') : null"
                class="agpr-rightSidebar-tabs"
                role="tablist"
                [attr.aria-orientation]="orientation"
                [tabindex]="_collapsible && !overlay ? '0' : '-1'"
                (keyup)="onKeyUp($event)"
            >
                @for (tab of tabs; track tab) {
                    <div
                        [attr.id]="tab.id ? (tab.id + '_container') : null"
                        class="agpr-rightSidebar-tabContainer"
                    >
                        @if (!tab.hidden) {
                            <li
                                class="agpr-rightSidebar-tab"
                                [ngClass]="{
                                    'agpr-rightSidebar-tab--selected': tab.selected,
                                    'agpr-rightSidebar-tab--disabled': tab.disabled,
                                    'agpr-rightSidebar-tabs--spacer': tab.showSpacer
                                }"
                                [id]="tab.id"
                                [agprTooltip]="tab.tooltip | localize"
                                [showDelay]="500"
                                tooltipPosition="left"
                                [attr.aria-label]="tab.tooltip | localize"
                                (click)="selectTab(tab)"
                                role="tab"
                                [attr.aria-controls]="tab.id + '.panel'"
                                [attr.aria-selected]="tab.selected ? true : false"
                            >
                                @if (!tab.useNumberWithIcon) {
                                    <i
                                        [attr.id]="tab.id ? (tab.id + '_icon') : null"
                                        [class]="getIconClasses(tab)"
                                    ></i>
                                } @else {
                                    @let notesLength = tab.description || 0;

                                    @let baseClass = 'agpr-rightSidebar-tab-noteText';
                                    @let selectedClass = baseClass + ' ' + baseClass + '-selected';

                                    @let noteTextClass = tab.selected ? selectedClass : baseClass;
                                    @let decimalNoteTextClass = baseClass + '-decimalNoteText';
                                    @let plusNoteTextClass = baseClass + '-plusNoteText';

                                    <span class="fa-layers fa-fw agpr-rightSidebar-tab-container">
                                        <i
                                            [attr.id]="tab.id ? (tab.id + '_icon') : null"
                                            [class]="getIconClasses(tab)"
                                        ></i>
                                        @if (notesLength >= 10) {
                                            <div>
                                                <span [class]="noteTextClass + ' ' + decimalNoteTextClass"> 9 </span>
                                                <span [class]="noteTextClass + ' ' + plusNoteTextClass"> + </span>
                                            </div>
                                        } @else {
                                            <span [class]="noteTextClass">{{ notesLength }}</span>
                                        }
                                    </span>
                                }
                            </li>
                            <div
                                [attr.id]="tab.id ? (tab.id + '_bar') : null"
                                class="agpr-rightSidebar-tabBar"
                                [ngClass]="{
                                    'agpr-rightSidebar-tabBar--selected': tab.selected,
                                    'agpr-rightSidebar-tabBar--spacer': tab.showSpacer
                                }"
                            >
                            </div>
                        }
                    </div>
                }
            </ul>
        }
        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
        <div
            *ngIf="showExtendedContent && tabExtended"
            class="agpr-rightSidebar-extended"
            [@fade]="fadeAnimation"
            (@fade.done)="fadeAnimationComplete($event)"
        >
            <agpr-scroll-panel>
                <div class="agpr-rightSidebar-scrollArea agpr-rightSidebar-scrollArea--noHeader agpr-rightSidebar-scrollArea--noFooter">
                    <ng-container *ngTemplateOutlet="tabExtended"></ng-container>
                </div>
            </agpr-scroll-panel>
        </div>
        @if (!tabs || tabs.length < 1 || _selectedTabIndex !== null) {
            <div
                [attr.id]="id ? (id + '_contents') : null"
                class="agpr-rightSidebar-contents"
                [ngStyle]="{ 'width': contentWidth }"
            >
                @if (header || tabHeader) {
                    <div
                        [attr.id]="id ? (id + '_header') : null"
                        class="agpr-rightSidebar-header"
                    >
                        @if (showTabTitle) {
                            <h3
                                class="agpr-rightSidebar-title"
                                [id]="selectedTab?.id + '_title'"
                            >
                                {{ selectedTab?.tooltip ? (selectedTab.tooltip | localize) : '' }}
                            </h3>
                        }
                        @if (header) {
                            <div [attr.id]="id ? (id + '_headerContent') : null">
                                <ng-container *ngTemplateOutlet="header"></ng-container>
                            </div>
                        }
                        @if (tabHeader) {
                            <div [attr.id]="id ? (id + '_tabHeader') : null">
                                <ng-container *ngTemplateOutlet="tabHeader"></ng-container>
                            </div>
                        }
                    </div>
                }
                <div
                    #contentContainer
                    [attr.id]="id ? (id + '_content') : null"
                    class="agpr-rightSidebar-content"
                    [agprLoading]="loading"
                >
                    <agpr-scroll-panel
                        #scrollPanel
                        [id]="id ? (id + '_scrollPanel') : null"
                    >
                        <div
                            [attr.id]="id ? (id + '_scrollArea') : null"
                            class="agpr-rightSidebar-scrollArea"
                            [class.agpr-rightSidebar-scrollArea--noHeader]="!header && !tabHeader"
                            [class.agpr-rightSidebar-scrollArea--noFooter]="!footer && !tabFooter"
                        >
                            @if (!(header || tabHeader) && showTabTitle) {
                                <h3
                                    class="agpr-rightSidebar-title"
                                    [ngClass]="{'agpr-rightSidebar-title-headerIcon': headerIcon}"
                                    [id]="selectedTab?.id + '_title'"
                                >
                                    @if (headerIcon) {
                                        <button
                                            class="agpr-rightSidebar-title-headerButton"
                                            [agprTooltip]="headerIconTooltip | localize"
                                            tooltipPosition="top"
                                            (click)="headerIconClicked.emit()"
                                        >
                                            <span
                                                [ngClass]="headerIcon"
                                                class="agpr-rightSidebar-title-headerButton-icon"
                                                aria-hidden="true"
                                            ></span>
                                        </button>
                                    }
                                    {{ selectedTab?.tooltip ? (selectedTab.tooltip | localize) : '' }}
                                </h3>
                            }
                            @if (content) {
                                <div class="agpr-rightSidebar-mainContent">
                                    <ng-container *ngTemplateOutlet="content"></ng-container>
                                </div>
                            }
                            <div
                                [attr.id]="id ? (id + '_mainContent') : null"
                                class="agpr-rightSidebar-mainContent"
                            >
                                <ng-content></ng-content>
                            </div>
                        </div>
                    </agpr-scroll-panel>
                </div>
                @if (footer || tabFooter) {
                    <div
                        [attr.id]="id ? (id + '_footer') : null"
                        class="agpr-rightSidebar-footer"
                        role="group"
                        [attr.aria-label]="'Common.rightSidebar.footer.controls' | localize"
                    >
                        @if (tabFooter) {
                            <div [attr.id]="id ? (id + '_tabFooter') : null">
                                <ng-container *ngTemplateOutlet="tabFooter"></ng-container>
                            </div>
                        }
                        @if (footer) {
                            <div [attr.id]="id ? (id + '_footerContent') : null">
                                <ng-container *ngTemplateOutlet="footer"></ng-container>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
</div>
